import VueI18n from 'vue-i18n';

let i18n: VueI18n;

export function initI18n(i18nInstance: VueI18n) {
    i18n = i18nInstance;
}

export function getI18n() {
    return i18n;
}
